import React, { useState, useEffect, useRef } from 'react';
import { Alert, Spinner, ListGroup, Badge } from 'react-bootstrap';

/**
 * MetadataFieldsStep - Step 3: Auto-create 4 standard metadata fields.
 * Triggers automatically on step entry.
 */
const MetadataFieldsStep = ({ wizard, api }) => {
  const [result, setResult] = useState(null);
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (!hasTriggered.current && wizard.sessionId) {
      hasTriggered.current = true;
      createFields();
    }
  }, [wizard.sessionId]);

  const createFields = async () => {
    try {
      const data = await api.createMetadataFields(wizard.sessionId);
      setResult(data);
      wizard.completeStep(3);
    } catch {
      // Error shown by hook
    }
  };

  if (api.loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" className="mb-3" />
        <p>Creating standard metadata fields...</p>
      </div>
    );
  }

  if (api.error) {
    return <Alert variant="danger">{api.error}</Alert>;
  }

  if (result) {
    return (
      <div>
        <Alert variant="success">
          <Alert.Heading>Metadata Fields Ready</Alert.Heading>
          <p>{result.totalCount} standard metadata field(s) verified.</p>
        </Alert>
        <ListGroup>
          {result.fields?.map((field, i) => (
            <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center">
              <div>
                <strong>{field.name}</strong>
                <span className="text-muted ms-2">({field.fieldKey})</span>
              </div>
              <Badge bg={field.wasCreated ? 'success' : 'secondary'}>
                {field.wasCreated ? 'Created' : 'Already Existed'}
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <p className="text-muted mt-3">Click "Next" to continue.</p>
      </div>
    );
  }

  return null;
};

export default MetadataFieldsStep;
